// @flow
import { browser } from '../base/lib-jitsi-meet';

export function isScreenAudioShared(state) {
    return state['features/screen-share'].isSharingAudio;
}

export function isScreenAudioSupported() {
    return browser.isChrome() || (browser.isElectron());
}

export function getScreenVideoShared(state) {
    return state['features/screen-share'].sharingVideo;
}

export function isScreenVideoSupported() {
    return browser.isChrome() || (browser.isElectron());
}
